export default "__VITE_ASSET__9627d122__"